module.exports = __webpack_public_path__ + "static/media/aboutCurveImage.4a79150b.png";